import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskLines, Reveal } from "@/components/site/Reveal";

const POINTS = [
  ["Turn up, as promised", "We show up when we say we will and keep you updated if anything changes."],
  ["Explain before we start", "You'll know what we found, what we recommend and what it will cost before work begins."],
  ["Leave it cleaner", "Drop sheets down, mess cleaned up, and the job tested before we leave."],
  ["Built on referrals", "Thirty years in the trade is built on builders, managers and homeowners calling us back."],
];

export const Legacy = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  return (
    <section ref={ref} data-testid="legacy-section" className="bg-bone py-24 sm:py-32 overflow-hidden">
      <div className="container-x grid gap-14 lg:grid-cols-12 items-center">
        <div className="lg:col-span-5 relative">
          <motion.p style={{ y }} className="font-wide font-black text-[11rem] sm:text-[16rem] lg:text-[20rem] leading-[0.8] tracking-tighter text-ink select-none" aria-hidden="true">
            30<span className="text-brass">.</span>
          </motion.p>
          <p className="eyebrow text-cobalt mt-4">Years on the tools across Sydney</p>
        </div>
        <div className="lg:col-span-7">
          <h2 className="font-wide font-black uppercase text-3xl sm:text-5xl leading-[0.95] tracking-tight">
            <MaskLines lines={["Three decades.", "No shortcuts."]} />
          </h2>
          <div className="mt-12 grid gap-3 sm:grid-cols-2">
            {POINTS.map(([t, d], i) => (
              <Reveal key={t} delay={i * 0.08} className="bg-white rounded-2xl shadow-[0_8px_30px_-12px_rgba(11,25,44,0.15)] p-6 sm:p-8">
                <p className="font-mono text-xs text-cobalt font-bold">0{i + 1}</p>
                <h3 className="font-wide font-extrabold text-xl mt-3">{t}</h3>
                <p className="mt-2 text-slate-600 text-sm leading-relaxed">{d}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
